var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnitRegistrationAssignment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "main_menu/Unit Registration and Assignment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_menu/Unit-Registration-and-Assignment",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52667374,29.1036052 L35.4252,39.4381 L18.1554544,53.8450038 C7.3858048,51.2929056 0,46.0506373 0,39.999 C0,35.7517085 3.63641322,31.9034035 9.52667374,29.1036052 Z M14.1401782,27.2772019 C19.4858281,25.5253892 25.9873991,24.498 33,24.498 C51.225,24.498 66,31.438 66,39.999 C66,42.3934035 64.8436851,44.6611015 62.7790037,46.6855966 L14.1401782,27.2772019 Z",
    id: "Shape",
    fill: "#97989D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6857997,49.1180807 C53.6851277,52.9848507 43.96723,55.498 33,55.498 C29.6275397,55.498 26.3732696,55.2603869 23.308918,54.8188707 L39.7002,41.1441 L59.6857997,49.1180807 Z",
    id: "Path",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3418,23.009 C45.1418,25.73 48.3998,29.767 52.5428,34.655 C56.5688,29.887 59.9458,25.73 61.7448,23.009 C64.5328,18.791 64.6408,12.647 60.5718,8.463 C56.1388,3.906 48.9488,3.906 44.5148,8.463 C40.4458,12.647 40.5528,18.791 43.3418,23.009",
    id: "Fill-136",
    fill: "#51C25D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8584,25.9811 C8.4274,29.8401 13.0814,35.5651 18.9994,42.4981 C24.7494,35.7361 29.5714,29.8401 32.1424,25.9811 C36.1254,19.9991 36.2784,11.2841 30.4664,5.3511 C24.1344,-1.1109 13.8664,-1.1109 7.5324,5.3511 C1.7224,11.2841 1.8744,19.9991 5.8584,25.9811",
    id: "Fill-138",
    fill: "#E04622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0391,23.3869 L12.9991,22.1509 L12.9991,14.9219 L19.0391,16.1579 L19.0391,23.3869 Z M16.9591,6.9949 L11.0001,10.9939 L11.0001,23.8129 L20.9961,25.8119 L26.9581,21.8129 L26.9581,8.9939 L16.9591,6.9949 Z",
    id: "Fill-140",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-142",
    fill: "#D9D9D9",
    points: "20.9961 25.8117 26.9581 21.8747 26.9581 8.9947 20.9961 12.9307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.541,20.7224 L48.378,19.8694 L48.378,14.8874 L52.541,15.7394 L52.541,20.7224 Z M51.107,9.4234 L47,12.1794 L47,21.0154 L53.891,22.3934 L58,19.6374 L58,10.8014 L51.107,9.4234 Z",
    id: "Fill-144",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-146",
    fill: "#D9D9D9",
    points: "53.8906 22.3937 57.9996 19.6807 57.9996 10.8017 53.8906 13.5147"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitRegistrationAssignment);
export default __webpack_public_path__ + "static/media/UnitRegistrationAssignment.b644f8246f0baa95085e61b09dd8bb27.svg";
export { ForwardRef as ReactComponent };